<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <div class="row  q-col-gutter-xs">
        <div class="col-md-12 col-xs-12">
          <q-card class="my-card bg-amber-2">
            <q-card-section>
              <div class="row q-col-gutter-xs">
                <div class="col-md-12 col-xs-12">
                  <div class="text-h6 text-center">RELATÓRIO DO HISTÓRICO GERAL</div>
                </div>
                <q-form class="col-12" ref="form">
                  <div class="row q-col-gutter-xs">
                    <div class="col-md-5">
                      <q-input outlined mask="##/##/####" :rules="[rules]"
                               v-model="init" label="Data de início">
                        <template v-slot:append>
                          <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy">
                              <q-date v-model="init" mask="DD/MM/YYYY" @input="() => $refs.qDateProxy.hide()"/>
                            </q-popup-proxy>
                          </q-icon>
                        </template>
                      </q-input>
                    </div>
                    <div class="col-md-5">
                      <q-input outlined mask="##/##/####" :rules="[rules]"
                               v-model="finish" label="Data de término">
                        <template v-slot:append>
                          <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy">
                              <q-date v-model="finish" mask="DD/MM/YYYY" @input="() => $refs.qDateProxy.hide()"/>
                            </q-popup-proxy>
                          </q-icon>
                        </template>
                      </q-input>
                    </div>
                    <div class="col-md-2">
                      <q-btn  label="Filtrar" type="a" target="_blank"
                              stretch size="lg"  tyle="width:100%;" rounded   :href="download"/>
                    </div>
                  </div>
                </q-form>
                <q-inner-loading :showing="loading">
                  <q-spinner-dots size="50px" color="primary"/>
                </q-inner-loading>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'DonationsReport',
  data () {
    return {
      finish: '',
      init: '',
      loading: false
    }
  },
  computed: {
    rules () {

    },
    download () {
      const host = process.env.VUE_APP_HOST.replace('graphql', 'general-history')
      const token = localStorage.getItem('token')
      const variavbles = []
      let init = this.init.split('/').reverse().join('-')
      variavbles.push('init=' + encodeURIComponent(init))
      let finish = this.finish.split('/').reverse().join('-')
      variavbles.push('finit=' + encodeURIComponent(finish))
      let query = variavbles.join('&')
      return `${host}?${query}&token=${token}`
    }
  }
}
</script>

<style scoped>

</style>
